export default __webpack_public_path__ + "static/media/ResetEffect.af1cdbbb.mp3";